module.exports = __webpack_public_path__ + "img/notice_img1.5e41e62f.png";